import { AsyncImage } from "loadable-image";
import { lazy, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "react-responsive-modal/styles.css";
import { Blur } from "transitions-kit";
import AddToCart from "../../utils/AddToCart";
import { GetItemPrice } from "../../utils/GetItemPrice";
import ParseFloat from "../../utils/ParseFloat";
import CustomizedModal from "../Modal/Customized-Modal";
import InfoModal from "../Modal/InfoModal";
import { setStoreCloseModal } from "../../redux/features/store";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useDeviceIos from "../../hooks/useDeviceIos";
import useMobile from "../../hooks/useMobile";
import useStoreStatus from "../../hooks/useStoreStatus";
import { CheckIsItemNormal } from "../../utils/item-utils/ItemTypeCheckUtils";
import AddonModel from "../Modal/Addon-Model";
import MealModal from "../Meal/MealModal";
import VariationModal from "../Modal/Variation-Modal";
export default function MenuCard({
  // classNameType,
  item,
  quantity,
  menu_id,
  taxdata,
  refrencePage
}: {
  classNameType?: string;
  item: any;
  quantity: number;
  menu_id: number;
  taxdata: any;
  refrencePage: string
}) {
  const [lang, setLang] = useState(i18next.language);
  const { translations }: any = useSelector((state: any) => state?.languageData);
  const navigate = useCustomNavigate();
  const isMobile = useMobile();
  const { items, itemCount } = useSelector((state: any) => state?.cartData);
  const selectedStore = useSelector((state: any) => state?.store?.selectedStore)
  const { t } = useTranslation()
  const device = useDeviceIos()
  const dispatch = useDispatch();

  const { returnIsStoreClose } = useStoreStatus()
  // const {
  //   variationData,
  //   customizedData,
  //   mealData
  // }: 
  //   any = useSelector((state: any) => state);
  // const { store: { storeDeliveryPickupType }, } = useSelector((state: any) => state);

  // console.log(device,"device")

  const variationData = useSelector((state: any) => state.variationData);
  const customizedData = useSelector((state: any) => state.customizedData);
  const mealData = useSelector((state: any) => state.mealData);
  const addonData = useSelector((state: any) => state?.AddonsData)


  //Konsole.log('returnIsStoreClose', returnIsStoreClose)

  const handleOpenStoreCloseModal = () => {
    dispatch(setStoreCloseModal(true))
  }
  const [open, setOpen] = useState(false);
  const [isInfo, setIsInfo] = useState(false);
  // useEffect(() => {
  //   if (open) {
  //     // openModalLock()
  //     // bodyScrollControl.enable(); // Disable body scroll
  //   } else {
  //     // closeModalLock()
  //     // bodyScrollControl.disable(); // Enable body scroll again

  //   }


 
  // }, [open])

  const onCloseModal = () => {
    // closeModalLock()
    setOpen(false);
  }

  // @@ redurect on mobile screen and open on other screen
  const handleOpen = (val: any, type?: any) => {
    // let selection_type = menuselection_varitaion;
    // if (customizedData && Object.keys(customizedData).length > 0) {
    //   selection_type = menuselection_cutomize
    // } else if (variationData && Object.keys(variationData).length > 0) {
    //   selection_type = menuselection_varitaion
    // } else if (mealData?.mealData && Object.keys(mealData?.mealData)?.length > 0) {
    //   selection_type = menuselection_meal;
    // }
    // if (isMobile && device) {
    //   navigate(`/menu/${type}`);
    // } else {
    //   setOpen(val)
    // }

    setOpen(val)


  }
  const returnImgUrl = useMemo(() => {
    let imgUrl = item?.item_attachment?.base_url + item?.item_attachment?.attachment_url;
    return imgUrl ? imgUrl : '/images/no_image_available.svg';
  }, [item?.item_attachment?.attachment_url]);

  //console.log('itemitemitem', item);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // Update screen width on window resize
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <>
      {/* @@ block for Featured item */}
      {(refrencePage == 'FeaturedItem') ? <>
        <div
          onClick={() => {
            if (returnIsStoreClose) {
              handleOpenStoreCloseModal();
            } else {
              AddToCart(item, item, items, dispatch, itemCount, menu_id, taxdata, handleOpen);
            }
          }}


          className="cardHeadWrapper-featured items-start gap-2 md:h-36 h-10 cursor-pointer">
          <div className="relative h-full">
            {/* md:w-36 w-36 */}
            <AsyncImage
              onError={'/images/no_image_available.svg' as any}
              loader={<div style={{ background: "#d3d3d3" }} />}
              key={returnImgUrl} src={returnImgUrl} />
            {quantity > 0 && (
              <button className="p-2 flex justify-center items-center rounded-full bg-white border border-black absolute bottom-2 right-2 w-8 h-8 text-base font-bold">
                {quantity}
              </button>

            )}
          </div>
        </div>
        {/* <p className="text-base font-medium">{item?.name}</p> */}
        <div className="cardTitle pe-2" style={{ paddingLeft: "1.2rem", paddingRight: "1.2rem" }}>{item?.name}</div>
        <p className=" textMd text-black font-normal">{ParseFloat(GetItemPrice(item))}</p>
      </> : <div className="rounded-xl md:border border-[#F3F3F3] bg-white w-full md:hover:bg-gray-100 ">
        {/* <div className={`sortType ${classNameType}`}>
          <div className="circleSize"></div>
        </div> */}
        <div
          className={`${returnIsStoreClose ? '' : ''} cardDetail cursor-pointer`}
          onClick={() => {
            if (returnIsStoreClose) {
              handleOpenStoreCloseModal();
            } else {
              AddToCart(item, item, items, dispatch, itemCount, menu_id, taxdata, handleOpen);
            }
          }}
        >
          <div className="cardHeadWrapper  items-start gap-2 lg:h-32 md:h-26  h-fit menu-height-data">
            <div className="md:p-4 p-0 flex flex-col justify-between">
              <div>
                <div className="cardTitle ">{item?.name}</div>

                <p className=" textMd text-black font-normal">
                  {ParseFloat(GetItemPrice(item))}
                </p>


                {/* {item?.description && (
                 <p className="cardDescription2">
                    <span className="">{item?.description}</span>
                    </p>

                )} */}

                {item?.description && <>
                  <p className="cardDescription2">
                    <span className="" onClick={() => {
                      if (CheckIsItemNormal(item) && ((isMobile && item?.description?.length > 50) || (!isMobile && item?.description?.length > 100))) {
                        setIsInfo(true);
                      }
                    }}>{item?.description}</span>
                  </p>
                </>}
              </div>
            </div>
            <div className="relative md:w-36 w-28 h-full group">
              <AsyncImage key={returnImgUrl} src={returnImgUrl} Transition={Blur} loader={<div style={{ background: "#d3d3d3" }} />} />

              {/* Quantity button - Positioned on the left */}
              {quantity > 0 && (
                <button className="p-2 flex justify-center items-center border border-black  rounded-full bg-white absolute bottom-2 right-2 w-8 h-8 text-base font-bold">
                  {quantity}
                </button>
              )}


              {/* Increment and decrement buttons - Positioned on the right */}
              {/* <div
                className="absolute bottom-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 overflow-hidden w-0 group-hover:w-auto transition-all duration-2000"
                style={{ transformOrigin: 'right' }}
              >
                {quantity > 0 && (
                  <button className="w-8 h-8 flex justify-center items-center  text-base bg-white font-bold rounded-full" onClick={() => DecrementItemData(item, items, dispatch, itemCount, taxdata)}>
                    - 
                  </button>
                )}
                <button
                  className="w-8 h-8 flex justify-center items-center  text-base font-bold bg-white rounded-full"
                  onClick={() => {
                    AddToCart(item, item, items, dispatch, itemCount, menu_id, taxdata, handleOpen);
                  }}
                >
                  + 
                </button>
              </div> */}
              {/* <button className="btn-secondary-sm">
              {!quantity ? (
                <span
                  className="block"
                  onClick={(e) => {
                    e.stopPropagation();
                    AddToCart( item, item, items, dispatch, itemCount, menu_id, taxdata, handleOpen);
                  }}
                >
                  Add
                </span>
              ) : (
                <div className="allCounterButton">
                  {quantity == 1 && checkItemType(item) == 3 && (
                    <span onClick={(e) => { e.stopPropagation(); DecrementItemData( item, items, dispatch, itemCount, taxdata);}}>
                      <svg width="12" height="12" viewBox="0 0 44 50" fill="currentColor">
                        <path d="M28.9062 42.1875H30.4688C30.8594 42.1875 31.25 41.8945 31.25 41.4062V14.8438C31.25 14.4531 30.8594 14.0625 30.4688 14.0625H28.9062C28.418 14.0625 28.125 14.4531 28.125 14.8438V41.4062C28.125 41.8945 28.418 42.1875 28.9062 42.1875ZM13.2812 42.1875H14.8438C15.2344 42.1875 15.625 41.8945 15.625 41.4062V14.8438C15.625 14.4531 15.2344 14.0625 14.8438 14.0625H13.2812C12.793 14.0625 12.5 14.4531 12.5 14.8438V41.4062C12.5 41.8945 12.793 42.1875 13.2812 42.1875ZM42.9688 6.25H32.8125L29.4922 1.95312C28.7109 0.878906 27.0508 0 25.7812 0H17.9688C16.6016 0 14.9414 0.878906 14.1602 1.95312L10.9375 6.25H0.78125C0.292969 6.25 0 6.64062 0 7.03125V8.59375C0 9.08203 0.292969 9.375 0.78125 9.375H3.125V45.3125C3.125 47.9492 5.17578 50 7.8125 50H35.9375C38.4766 50 40.625 47.9492 40.625 45.3125V9.375H42.9688C43.3594 9.375 43.75 9.08203 43.75 8.59375V7.03125C43.75 6.64062 43.3594 6.25 42.9688 6.25ZM16.6992 3.80859C16.8945 3.41797 17.4805 3.22266 17.9688 3.125H25.7812C26.1719 3.22266 26.7578 3.41797 26.9531 3.80859L28.9062 6.25H14.8438L16.6992 3.80859ZM37.5 45.3125C37.5 46.1914 36.7188 46.875 35.9375 46.875H7.8125C6.93359 46.875 6.25 46.1914 6.25 45.3125V9.375H37.5V45.3125ZM21.0938 42.1875H22.6562C23.0469 42.1875 23.4375 41.8945 23.4375 41.4062V14.8438C23.4375 14.4531 23.0469 14.0625 22.6562 14.0625H21.0938C20.6055 14.0625 20.3125 14.4531 20.3125 14.8438V41.4062C20.3125 41.8945 20.6055 42.1875 21.0938 42.1875Z"></path>
                      </svg>
                    </span>
                  )}
                  {quantity > 1 && checkItemType(item) == 3 && (
                    <span className="" onClick={(e) => { e.stopPropagation(); DecrementItemData( item, items, dispatch, itemCount, taxdata);}}>
                      <svg width="12" height="12" viewBox="0 0 38 5" fill="currentColor">
                        <path d="M36.7188 0H0.78125C0.292969 0 0 0.390625 0 0.78125V3.90625C0 4.39453 0.292969 4.6875 0.78125 4.6875H36.7188C37.1094 4.6875 37.5 4.39453 37.5 3.90625V0.78125C37.5 0.390625 37.1094 0 36.7188 0Z"></path>
                      </svg>
                    </span>
                  )}
                  {quantity > 0 && <span>{quantity}</span>}
                  {!quantity ? (
                    <span
                      className=""
                      onClick={(e) => { e.stopPropagation(); AddToCart( item, item, items, dispatch, itemCount, menu_id, taxdata, handleOpen);}}
                    >
                      <svg width="12" height="12" viewBox="0 0 38 38" fill="currentColor">
                        <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
                      </svg>
                    </span>
                  ) : (
                    checkItemType(item) != 3 && (
                      <span className="" onClick={(e) => { e.stopPropagation(); AddToCart( item, item, items, dispatch, itemCount, menu_id, taxdata, handleOpen);}}>
                        <svg width="12" height="12" viewBox="0 0 38 38" fill="currentColor">
                          <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
                        </svg>
                      </span>
                    )
                  )}

                  {quantity >= 1 && checkItemType(item) == 3 && (
                    <span
                      className=""
                      onClick={(e) => {
                        e.stopPropagation();
                        incrementItemData( item, items, dispatch, itemCount, taxdata);
                      }}
                    >
                      <svg width="12" height="12" viewBox="0 0 38 38" fill="currentColor">
                        <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
                      </svg>
                    </span>
                  )}
                </div>
              )}
            </button> */}
            </div>
          </div>
        </div>
      </div>}


      {/* customized .... */}
      {open && customizedData && Object.keys(customizedData).length > 0 && (
        <CustomizedModal
          menu_id={menu_id}
          taxdata={taxdata}
          open={open}
          onCloseModal={onCloseModal}
        />
      )}

      {/* Addon......*/}
      {open && addonData && Object.keys(addonData).length > 0 && (
        <div className="animate-modalOpen transition-all duration-300 ease-out">

          <AddonModel
            menu_id={menu_id}
            taxdata={taxdata}
            open={open}
            onCloseModal={onCloseModal}
          />
        </div>
      )}

      {/* variation ... */}
      {open && variationData && Object.keys(variationData).length > 0 && (
        <div className="animate-modalOpen transition-all duration-300 ease-out">
          <VariationModal
            menu_id={menu_id}
            taxdata={taxdata}
            open={open}
            onCloseModal={onCloseModal}
          />
        </div>
      )}
      {/* Meal ... */}
      {open && mealData?.mealData && Object.keys(mealData?.mealData)?.length > 0 && (
        <MealModal
          menu_id={menu_id}
          taxdata={taxdata}
          open={open}
          onCloseModal={onCloseModal}
        />
      )}
      {<InfoModal item={item} isInfo={isInfo} setIsInfo={setIsInfo} lang={lang} translations={translations} />}
    </>
  );
}
